// assets
import { IconReport } from '@tabler/icons';
import transChild from './TransChild';

// constant
const icons = { IconReport };

const transactionReportGrp = {
    id: `transactionReportgrp-${Math.random()}`,
    title: 'Transaction Report',
    type: 'group',
    // url: `/dashboard/default`,
    icon: icons.IconReport,
    breadcrumbs: false,
    children: transChild,
    role: process.env.REACT_APP_RL_TRANSGRP
};

export default transactionReportGrp;